import instance  from "@/api/instance";
const END_POINT = '/api';

const main = {
    getList: () => instance.get(`${END_POINT}/index`),
}


export default {
    main
}